import { SMS_CODE_MODAL } from "../../getContent/constants";
import { produce } from "../../../../libs/immer";
import { findFirst } from "../../../../utils/arrays";
import { EStatus } from "../../../../constants";
import { isLowerCaseEquals } from "../../../../utils/strings";
import { ERegisterStatus } from "../constants";
export var getSmsCode = function getSmsCode(state, isSmsResend) {
  var _state$scenario;
  return ((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) === SMS_CODE_MODAL && !isSmsResend ? Number(state.scenario.codeInput.value) : undefined;
};
export var processSmsStatus = function processSmsStatus(setState, status) {
  if (status && isLowerCaseEquals(status, ERegisterStatus.SmsCode)) {
    setState(produce(function (draft) {
      draft.scenario = {
        type: SMS_CODE_MODAL,
        codeInput: {
          value: ''
        }
      };
    }));
  }
  if (status && isLowerCaseEquals(status, ERegisterStatus.IncorrectSmsCode)) {
    setState(produce(function (draft) {
      var _draft$scenario;
      draft.scenario = {
        type: SMS_CODE_MODAL,
        codeInput: {
          value: ((_draft$scenario = draft.scenario) === null || _draft$scenario === void 0 ? void 0 : _draft$scenario.type) === SMS_CODE_MODAL ? draft.scenario.codeInput.value : '',
          errorMessage: 'error'
        }
      };
    }));
  }
  var result = findFirst([status && isLowerCaseEquals(status, ERegisterStatus.CheckSmsMaxAttempts) && EStatus.CheckSmsMaxAttempts, status && isLowerCaseEquals(status, ERegisterStatus.SendSmsCodeMaxAttempts) && EStatus.SendSmsCodeMaxAttempts, status && isLowerCaseEquals(status, ERegisterStatus.SmsCodeExpired) && EStatus.SmsCodeExpired]);
  if (result) {
    setState(produce(function (draft) {
      draft.statusPopup = result;
    }));
  }
};